<template>
  <div>
    <v-layout wrap justify-center pt-10>
      <v-flex xs12 sm12 md12 lg12>
        <v-layout wrap justify-center style="background-color: #3d673a;">
          <v-flex xs12 sm12 md11 lg11>
            <v-layout wrap justify-center pa-6>
              <v-flex xs12>
                <h2 class="text-center text-bold" style="color:#ffcf59;font-size:40px">Thesis Team</h2>
              </v-flex>
              
              <v-flex xs12 sm6 md4 lg3 v-for="(alumni, index) in alumniList" :key="index" class="pa-4">
                <v-card class="pa-4 d-flex flex-column justify-space-between" style="background-color: #ffcf59; height: 100%;">
                  <!-- Content Section -->
                  <div>
                    <v-avatar color="white" size="90" class="mx-auto mb-4">
                      <v-icon size="64" color="#3d673a">mdi-account</v-icon>
                    </v-avatar>
    
                    <h3 class="text-left text-bold" style="color:#3d673a;font-family:poppinsbold">{{ alumni.name }}</h3>
                    <h3 style="color:#3d673a;font-family:poppinsbold" class="text-left mb-1 text-bold">{{ alumni.cohort }}</h3>
                    <p style="color:grey;font-family:poppinsregular" class="text-left">{{ alumni.designation }}</p>
                    <p style="color:black;font-family:poppinsregular" class="text-center">{{ alumni.desc }}</p>
                  </div>
    
                  <!-- Button Section -->
          <div class="mt-auto">
            <v-btn
              block
              style="background-color: #3d673a;"
              class="mt-4"
              text
              @click="openshowVideo(alumni.videoLink)"
            >
              <span style="color: #ffcf59; text-decoration:underline">
                Watch Video
              </span>
            </v-btn>
          </div>
                </v-card>
              </v-flex>
    
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
     <!-- Video Dialog -->
     <v-dialog v-model="showVideo" width="70%" persistent>
      <v-card>
        <v-card-title class="headline">Watch Video</v-card-title>
        <v-card-text>
          <iframe
            v-if="currentVideo"
            :src="currentVideo"
            width="100%"
            height="400"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeVideo">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false,
      currentVideo: "",
      alumniList: [
        {
          name: "Nayantara Siruguri",
          cohort: "2020-2022 Cohort",
          designation: "Nature Education Coordinator at Canopy Collective",
          image: require("../assets/Images/account.jpg"),
          desc: "Thesis Title: Bats in the classroom: the effects of an environmental education (EE) intervention on children's perception of bats in Maharashtra, India",
          videoLink: "https://www.youtube.com/embed/laoyeTLkEIY",
        },
        {
          name: "Tanaya Rele",
          cohort: "(2021-2023 Cohort)",
          designation:
            "Project Assistant at Nature Classrooms, Nature Conservation Foundation",
          image: "path-to-sharath-image.jpg",
          desc: "Thesis Title: The Greens in the Grey: Perceptions of people towards the aesthetic and ecological aspects of urban parks in Mumbai, India",
          videoLink: "https://www.youtube.com/embed/5b0hOmSYoKA",
        },
        {
          name: "Aswathi AsokanRajiv N V ",
          cohort: "(2021-2023 Cohort)",
          designation:
            "Research Fellow at the National Centre for Biological Sciences (NCBS)",
          desc: "Thesis Title: Intergenerational transmission of cultural values: A study on sacred groves in Siddapur, India",
          image: "path-to-aswathi-image.jpg",
          videoLink: "https://www.youtube.com/embed/tI4_wOlFtQk",
        },
        {
          name: "Aditi Rao",
          cohort: " ( 2022-2024 Cohort)",
          designation:
            "Fellow at Nature Classrooms, Nature Conservation Foundation",
          image: "path-to-jayaram-image.jpg",
          desc: "Thesis Title: Threads of Time: Intergenerational Transmission of Traditional Ecological Knowledge About Tubers in Uttara Kannada’s Kunbi Community",
          videoLink: "https://www.youtube.com/embed/qI6Ye3K6CUY",
        },
      ],
    };
  },
  methods: {
    openshowVideo(videoLink) {
      this.currentVideo = videoLink;
      this.showVideo = true;
    },
    closeVideo() {
      this.showVideo = false;
      this.currentVideo = null;
    },
  },
};
</script>

<style scoped>
.text-bold {
  font-weight: bold;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>